<template>
  <el-row class="home-block-title-wrap">
    <div class="title">
      {{ title }}
    </div>
    <div class="more">
      <router-link :to="link" tag="div">
        <span>{{ linkText }}</span>
      </router-link>
    </div>
  </el-row>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ""
      },
      linkText: {
        type: String,
        default: ""
      },
      link: {
        type: Object,
        default: function () {
          return { name: "学院介绍", query: { tab: "3" } }
        }
      }
    },
    data() {
      return {}
    },
    created() {},
    mounted() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .home-block-title-wrap {
    height: 30px;
    line-height: 30px;
    font-size: 22px;
    color: #313131;
    display: flex;

    .title {
      background: transparent url("~@/assets/images/icon_13.png") no-repeat left
        center;
      background-size: auto 100%;
      padding-left: 18px;
      flex: 1;
    }

    .more {
      color: #006ff6;
      font-size: 18px;
      cursor: pointer;
    }
  }

  @media (max-width: 1200px) {
    .home-block-title-wrap {
      .more {
        span {
          visibility: hidden;
        }
        width: 60px;
        background: transparent url("~@/assets/images/phone/sub_more.png")
          no-repeat 50px center;
      }
    }
  }
</style>
